import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL;

export function getAccountHistory(ClientId) {
  return apiUtils
    .get(`${baseUrl}/ClientPayments/${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function asanaTicket(params) {
  return apiUtils
    .post(`${baseUrl}/ClientPayments/AsanaTicket/`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateSecurePayment(params) {
  return apiUtils
    .post(`${baseUrl}/ClientPayments/ValidateSecurePayment/`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function securePayment(params) {
  return apiUtils
    .post(`${baseUrl}/ClientPayments/SecurePayment/`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function createPayment(params) {
  return apiUtils
    .post(`${baseUrl}/ClientPayments/MakePayment/`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function createInvoicePayment(params) {
  return apiUtils
    .post(`${baseUrl}/ClientPayments/MakeInvoicePayment/`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getInvoice(invoiceId, clientId, jurisdictionID) {
  return apiUtils
    .get(
      `${baseUrl}/Invoices/GetInvoice/${clientId}/${invoiceId}/${jurisdictionID}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getPaymentMethod(ClientId) {
  return apiUtils
    .get(`${baseUrl}/PaymentMethods/${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getInvoiceEstimateSummary(params) {
  return apiUtils
    .get(
      `${baseUrl}/ClientPayments/InvoiceEstimateSummary/?clientId=${params.clientId}&vehicleId=${params.vehicleId}&serviceId=${params.serviceId}&locationId=${params.locationId}&jurisdictionId=${params.jurisdictionId}&dayQuantity=${params.dayQuantity}&earlyService=${params.earlyService}&expedientShipping=${params.expedientShipping}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updatePaymentMethod(RecurringPaymentCardID, params) {
  return apiUtils
    .put(`${baseUrl}/PaymentMethods/UpdateCard`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function deletePaymentMethod(RecurringPaymentCardID, params) {
  return apiUtils
    ._delete(`${baseUrl}/PaymentMethods/DeleteCard`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function createPaymentMethod(params) {
  return apiUtils
    .post(`${baseUrl}/PaymentMethods/AddCard`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
